import {
  _COMMIT_LOG, _PROCESS_ERROR, ACCT_GET_ACCOUNT, ACCT_GET_ACCOUNT_BY_EXT_KEY, ACCT_GET_ACCOUNT_INVOICES, ACCT_GET_ACCOUNTS,
  ACCT_UPDATE_STMT_METH, ACCT_UPDATE_CREDIT_CARD, ACCT_UPDATE_ECHECK, ACCT_POST_PAYMENT_CC, ACCT_POST_PAYMENT_ECHECK,
  ACCT_GET_ACCOUNT_SERVICES, ACCT_GET_ACCOUNT_TICKETS, ACCT_GET_ACCOUNT_RATES, ACCT_GET_ACCOUNT_PAYMENTS, ACCT_GET_ACCOUNT_FORMS,
  ACCT_GET_ACCOUNT_ACTIVITY, ACCT_GET_ACCOUNT_USERS, ACCT_POST_PAYMENT_CASH, ACCT_POST_PAYMENT_CHECK,
  ACCT_POST_PAYMENT_MONEYORDER, ACCT_POST_PAYMENT_VOID, ACCT_GET_ACCOUNT_CORRESPONDENCES,
  ACCT_ASSIGN_PLAN, ACCT_CHANGE_PLAN, ACCT_REMOVE_PLAN, ACCT_ASSIGN_LOGIN, ACCT_REMOVE_LOGIN, ACCT_POST_CHARGES,
  ACCT_SEND_INVOICES,
} from './actions.types'
import {
  ACCT_SET_ACCOUNTS, ACCT_SET_SELECTED_ACCOUNT, ACCT_UPDATE_SELECTED_ACCOUNT,
  ACCT_SET_IS_GETTINGACCOUNT, ACCT_SET_IS_GETTINGACCOUNTS, ACCT_SET_IS_UPDATINGPAYMENTDETAILS,
  ACCT_SET_ERRORS_CC_FORM, ACCT_SET_ERRORS_ECHECK_FORM, ACCT_SET_IS_GETTINGACCOUNTINVOICES,
  ACCT_SET_SELECTED_ACCOUNT_UNPAID_INVOICES, ACCT_SET_IS_POSTINGPAYMENT, ACCT_SET_ERRORS_POST_PAYMENT,
  ACCT_SET_ERRORS, ACCT_SET_SELECTED_ACCOUNT_SERVICES, ACCT_SET_SELECTED_ACCOUNT_INVOICES, ACCT_SET_SELECTED_ACCOUNT_RATES,
  ACCT_SET_SELECTED_ACCOUNT_EQUIP, ACCT_SET_SELECTED_ACCOUNT_TKTS, ACCT_UPDATE_SELECTED_ACCOUNT_UNPAID_INV, ACCT_SET_SELECTED_ACCOUNT_FORMS,
  ACCT_SET_SELECTED_ACCOUNT_ACTIVITY, ACCT_SET_SELECTED_ACCOUNT_USERS, ACCT_UPDATE_SELECTED_ACCOUNT_KEY,
} from './mutations.types'
import ApiService from '../services/api.service'
import CorrespondenceService from '../services/correspondence.service'
import PlatypusService from '../services/platypus.service'

const initialState = {
  errors: [],
  ccFormErrors: [],
  echeckFormErrors: [],
  postPaymentErrors: [],
  accounts: [],
  selectedAccount: {
    full_name: '',
    display_text: '',
    status: '',
    is_reviewed: false,
    external_type: '',
    external_key: '',
    _statementMethod: '',
    _balanceDetails: {
      paid: 0,
      total: 0,
      balance: 0,
    },
    _vehicleDetails: {
      vehicle_requirement: 1,
      vehicle_requirement_text: '',
      vehicle_notes: '',
    },
    _addresses: {
      billing: {
        attn: '',
        addr1: '',
        city: '',
        state: '',
        zip: '',
      },
      echeck: {
        attn: '',
        addr1: '',
        city: '',
        state: '',
        zip: '',
      },
      shipping: {
        attn: '',
        addr1: '',
        city: '',
        state: '',
        zip: '',
      },
      creditCard: {
        attn: '',
        addr1: '',
        city: '',
        state: '',
        zip: '',
      },
    },
    _echeckInfo: {
      attn: '',
      bank_acct_type: '',
      routenumber: '',
      banknumbermasked: '',
      acctnumber: '',
    },
    _ccInfo: {
      attn: '',
      cctype: '',
      creditcardmasked: '',
      acctnumber: '',
      ccMonth: null,
      ccYear: null,
    },
    invoices: [],
    unpaidInvoices: [],
  },
  selectedAccountUnpaidInvoices: [],
  selectedAccountInvoices: [],
  selectedAccountServices: {
    email: [],
    wireless: [],
    pppoe: [],
    static: [],
  },
  selectedAccountActivity: [],
  selectedAccountEquipment: [],
  selectedAccountForms: [],
  selectedAccountRates: [],
  selectedAccountTickets: [],
  selectedAccountUsers: [],
  isGettingAccount: false,
  isGettingAccountInvoices: false,
  isGettingAccounts: false,
  isUpdatingPaymentDetails: false,
  isPostingPayment: false,
}

export const state = { ...initialState }

export const actions = {
  /***
   * Get account based on rowkey
   * @param {string} payload.rowkey identifier of the account to view
   * @returns {*}
   */
  async [ACCT_GET_ACCOUNT] ({ dispatch, commit, rootState }, payload) {
    commit(ACCT_SET_IS_GETTINGACCOUNT, true)
    try {
      dispatch(_COMMIT_LOG, { message: 'Retrieving account details:', payload })
      const response = await ApiService.query(`account/${payload.rowkey}`, {})
      dispatch(_COMMIT_LOG, { message: 'account details returned:', payload: response.data })
      commit(ACCT_SET_SELECTED_ACCOUNT, response.data)
      commit(ACCT_SET_IS_GETTINGACCOUNT, false)
      commit(ACCT_SET_ERRORS, [])
      return response.data
    } catch (e) {
      const processedError = await dispatch(_PROCESS_ERROR, e)
      console.log(processedError)
      commit(ACCT_SET_IS_GETTINGACCOUNT, false)
      commit(ACCT_SET_IS_GETTINGACCOUNT, initialState.selectedAccount)
      commit(ACCT_SET_ERRORS, ['Error while retrieving account details'])
      return false
    }
  },
  /***
   * Get account activity
   * @param {string} payload.rowkey identifier of the account to view
   * @returns {*}
   */
  async [ACCT_GET_ACCOUNT_ACTIVITY] ({ dispatch, commit, rootState, state }, payload) {
    try {
      if (!payload) {
        dispatch(_COMMIT_LOG, { message: 'Setting payload.rowkey to selected account' })
        payload = {
          rowkey: state.selectedAccount.rowkey,
        }
      }
      dispatch(_COMMIT_LOG, { message: 'Retrieving account activity:', payload })
      const response = await ApiService.query(`account/${payload.rowkey}/activity`, { ...payload })
      dispatch(_COMMIT_LOG, { message: 'Account activity: ', response: response.data })
      commit(ACCT_SET_SELECTED_ACCOUNT_ACTIVITY, response.data)
      commit(ACCT_SET_ERRORS, [])
      return response.data
    } catch (e) {
      const processedError = await dispatch(_PROCESS_ERROR, e)
      dispatch(_COMMIT_LOG, { message: 'processed error retrieving account activity', processedError })
      commit(ACCT_SET_SELECTED_ACCOUNT_ACTIVITY, [])
      commit(ACCT_SET_ERRORS, ['Error while retrieving account activity'])
      return false
    }
  },
  /***
   * Get account forms based on account rowkey
   * @param {string} payload.rowkey identifier of the account to view
   * @returns {*}
   */
  async [ACCT_GET_ACCOUNT_FORMS] ({ dispatch, commit, rootState }, payload) {
    try {
      dispatch(_COMMIT_LOG, { message: 'Retrieving account forms:', payload })
      const response = await ApiService.query(`account/${payload.rowkey}/forms`, { ...payload })
      dispatch(_COMMIT_LOG, { message: 'Account forms: ', data: response.data })
      commit(ACCT_SET_SELECTED_ACCOUNT_FORMS, response.data)
      commit(ACCT_SET_ERRORS, [])
      return response.data
    } catch (e) {
      const processedError = await dispatch(_PROCESS_ERROR, e)
      dispatch(_COMMIT_LOG, { message: 'processedError', processedError })
      commit(ACCT_SET_SELECTED_ACCOUNT_FORMS, [])
      commit(ACCT_SET_ERRORS, ['Error while retrieving forms'])
      return false
    }
  },
  /***
   * Get account invoices based on rowkey
   * @param {string} payload.rowkey identifier of the account to view
   * @param {boolean} payload.unpaid flag to get all invoices or just unpaid
   * @returns {*}
   */
  async [ACCT_GET_ACCOUNT_INVOICES] ({ dispatch, commit, rootState, state }, payload) {
    if (!payload) {
      payload = {
        rowkey: state.selectedAccount.rowkey,
        unpaid: false,
      }
    }
    commit(ACCT_SET_IS_GETTINGACCOUNTINVOICES, true)
    try {
      console.log('Retrieving account invoices:', payload)
      const response = await ApiService.query(`account/${payload.rowkey}/invoices`, { ...payload })
      console.log('Account invoices: ', response.data)
      if (payload.unpaid) {
        const invoices = response.data
        for (let i = 0; i < invoices.length; i++) {
          invoices[i].selected = false
        }
        commit(ACCT_SET_SELECTED_ACCOUNT_UNPAID_INVOICES, response.data)
      } else {
        commit(ACCT_SET_SELECTED_ACCOUNT_INVOICES, response.data)
      }
      commit(ACCT_SET_IS_GETTINGACCOUNTINVOICES, false)
      commit(ACCT_SET_ERRORS, [])
      return response.data
    } catch (e) {
      const processedError = await dispatch(_PROCESS_ERROR, e)
      console.log(processedError)
      commit(ACCT_SET_IS_GETTINGACCOUNTINVOICES, false)
      if (payload.unpaid) {
        commit(ACCT_SET_SELECTED_ACCOUNT_UNPAID_INVOICES, [])
      } else {
        commit(ACCT_SET_SELECTED_ACCOUNT_INVOICES, [])
      }
      commit(ACCT_SET_ERRORS, ['Error while retrieving invoices'])
      return false
    }
  },
  /***
   * Get account correspondences
   * @param {integer} payload.page identifier of the account to view
   * @param {integer} payload.pageSize identifier of the account to view
   * @returns {*}
   */
  async [ACCT_GET_ACCOUNT_CORRESPONDENCES] ({ dispatch, commit, rootState, state }, payload) {
    if (!payload) {
      payload = {
        page: 1,
        pageSize: 50,
      }
    }
    payload.filterAccount = {
      op: 'in',
      value: [
        state.selectedAccount.rowkey,
      ],
    }
    try {
      dispatch(_COMMIT_LOG, { message: 'Retrieving account correspondence:', payload })
      const { data } = await CorrespondenceService.query(payload)
      dispatch(_COMMIT_LOG, { message: 'Account correspondence response: ', query: payload, response: data })

      // commit(ACCT_SET_SELECTED_ACCOUNT_CORRESPONDENCES, data.items)

      commit(ACCT_SET_ERRORS, [])
      return data
    } catch (e) {
      const processedError = await dispatch(_PROCESS_ERROR, e)
      dispatch(_COMMIT_LOG, { message: 'Error retrieving correspondence ', error: processedError })
      return false
    }
  },
  /***
   * Get account payments
   * @param {integer} payload.page page index to query
   * @param {integer} payload.pageSize number of records to return
   * @param {integer} payload.orderBy column and direction to sort
   * @returns {*}
   */
  async [ACCT_GET_ACCOUNT_PAYMENTS] ({ dispatch, commit, rootState, state }, payload) {
    if (!payload) {
      payload = {
        page: 1,
        pageSize: 50,
      }
    }
    payload.filterAccountKey = state.selectedAccount.rowkey

    try {
      dispatch(_COMMIT_LOG, { message: 'Retrieving account payments:', payload })
      const { data } = await PlatypusService.queryPayments(payload)
      dispatch(_COMMIT_LOG, { message: 'Account payment response: ', query: payload, response: data })

      // commit(ACCT_SET_SELECTED_ACCOUNT_CORRESPONDENCES, data.items)

      commit(ACCT_SET_ERRORS, [])
      return data
    } catch (e) {
      const processedError = await dispatch(_PROCESS_ERROR, e)
      dispatch(_COMMIT_LOG, { message: 'Error retrieving correspondence ', error: processedError })
      return false
    }
  },
  /***
   * Get account rates based on rowkey
   * @param {string} payload.rowkey identifier of the account to view
   * @returns {*}
   */
  async [ACCT_GET_ACCOUNT_RATES] ({ dispatch, commit, state, rootState }, payload) {
    try {
      const requestPayload = {
        ...payload,
      }
      if (!requestPayload.rowkey) {
        requestPayload.rowkey = state.selectedAccount.rowkey
      }
      await dispatch(_COMMIT_LOG, { message: 'retrieving rates for account', requestPayload })
      const response = await ApiService.query(`account/${requestPayload.rowkey}/rates`, { ...requestPayload })
      await dispatch(_COMMIT_LOG, { message: 'rates response: ', response: response.data })
      commit(ACCT_SET_SELECTED_ACCOUNT_RATES, response.data)
      commit(ACCT_SET_ERRORS, [])
      return response.data
    } catch (e) {
      const processedError = await dispatch(_PROCESS_ERROR, e)
      console.log(processedError)
      commit(ACCT_SET_SELECTED_ACCOUNT_RATES, [])
      commit(ACCT_SET_ERRORS, ['Error while retrieving tickets'])
      return false
    }
  },
  /***
   * Get account services based on rowkey
   * @param {string} payload.rowkey identifier of the account to view
   * @returns {*}
   */
  async [ACCT_GET_ACCOUNT_SERVICES] ({ dispatch, commit, rootState }, payload) {
    commit(ACCT_SET_IS_GETTINGACCOUNTINVOICES, true)
    try {
      console.log('Retrieving account services:', payload)
      const response = await ApiService.query(`account/${payload.rowkey}/services`, { ...payload })
      console.log('Account services: ', response.data)
      commit(ACCT_SET_SELECTED_ACCOUNT_UNPAID_INVOICES, response.data)
      commit(ACCT_SET_IS_GETTINGACCOUNTINVOICES, false)
      commit(ACCT_SET_ERRORS, [])
      return response.data
    } catch (e) {
      const processedError = await dispatch(_PROCESS_ERROR, e)
      console.log(processedError)
      commit(ACCT_SET_IS_GETTINGACCOUNTINVOICES, false)
      commit(ACCT_SET_SELECTED_ACCOUNT_UNPAID_INVOICES, [])
      commit(ACCT_SET_ERRORS, ['Error while retrieving invoices'])
      return false
    }
  },
  /***
   * Get account tickets based on rowkey
   * @param {string} payload.rowkey identifier of the account to view
   * @returns {*}
   */
  async [ACCT_GET_ACCOUNT_TICKETS] ({ dispatch, commit, rootState }, payload) {
    try {
      console.log('Retrieving account tickets:', payload)
      const response = await ApiService.query(`account/${payload.rowkey}/tickets`, { ...payload })
      console.log('Account tickets: ', response.data)
      commit(ACCT_SET_SELECTED_ACCOUNT_TKTS, response.data)
      commit(ACCT_SET_ERRORS, [])
      return response.data
    } catch (e) {
      const processedError = await dispatch(_PROCESS_ERROR, e)
      console.log(processedError)
      commit(ACCT_SET_IS_GETTINGACCOUNTINVOICES, false)
      commit(ACCT_SET_SELECTED_ACCOUNT_TKTS, [])
      commit(ACCT_SET_ERRORS, ['Error while retrieving tickets'])
      return false
    }
  },
  /***
   * Get account users
   * @param {string} payload.rowkey identifier of the account to view
   * @returns {*}
   */
  async [ACCT_GET_ACCOUNT_USERS] ({ dispatch, commit, rootState, state }, payload) {
    try {
      if (!payload) {
        dispatch(_COMMIT_LOG, { message: 'Setting payload.rowkey to selected account' })
        payload = {
          rowkey: state.selectedAccount.rowkey,
        }
      }
      dispatch(_COMMIT_LOG, { message: 'Retrieving account users:', payload })
      const response = await ApiService.query(`account/${payload.rowkey}/users`, { ...payload })
      dispatch(_COMMIT_LOG, { message: 'Account users returned: ', users: response.data })
      commit(ACCT_SET_SELECTED_ACCOUNT_USERS, response.data)
      commit(ACCT_SET_ERRORS, [])
      return response.data
    } catch (e) {
      const processedError = await dispatch(_PROCESS_ERROR, e)
      dispatch(_COMMIT_LOG, { message: 'processed error retrieving account users', processedError })
      commit(ACCT_SET_SELECTED_ACCOUNT_USERS, [])
      commit(ACCT_SET_ERRORS, ['Error while retrieving users'])
      return false
    }
  },
  /***
   * Assign Login
   * @param {string} payload.account_key UUID of the account to assign user to
   * @param {string} payload.login user email/login to assign access
   * @returns {*}
   */
  async [ACCT_ASSIGN_LOGIN] ({ dispatch, commit, state, rootState }, payload) {
    try {
      const assignPayload = {
        ...payload,
      }
      if (!assignPayload.account_key) {
        assignPayload.account_key = state.selectedAccount.rowkey
      }
      await dispatch(_COMMIT_LOG, { message: 'Assigning user login', assignPayload })
      const response = await ApiService.postAction('account', assignPayload.account_key, 'assign-login', assignPayload)
      await dispatch(_COMMIT_LOG, { message: 'POST:assign-login response', response: response.data })
      commit(ACCT_SET_ERRORS, [])
      return response.data
    } catch (e) {
      const processedError = await dispatch(_PROCESS_ERROR, e)
      console.log(processedError)
      commit(ACCT_SET_IS_GETTINGACCOUNT, false)
      commit(ACCT_SET_ERRORS, ['Error while assigning user login'])
      return false
    }
  },
  /***
   * Remove Login
   * @param {string} payload.account_key UUID of the account to remove user from
   * @param {string} payload.login user email/login to remove access
   * @returns {*}
   */
  async [ACCT_REMOVE_LOGIN] ({ dispatch, commit, state, rootState }, payload) {
    try {
      const assignPayload = {
        ...payload,
      }
      if (!assignPayload.account_key) {
        assignPayload.account_key = state.selectedAccount.rowkey
      }
      await dispatch(_COMMIT_LOG, { message: 'removing user login', assignPayload })
      const response = await ApiService.postAction('account', assignPayload.account_key, 'remove-login', assignPayload)
      await dispatch(_COMMIT_LOG, { message: 'POST:remove-login response', response: response.data })
      commit(ACCT_SET_ERRORS, [])
      return response.data
    } catch (e) {
      const processedError = await dispatch(_PROCESS_ERROR, e)
      console.log(processedError)
      commit(ACCT_SET_IS_GETTINGACCOUNT, false)
      commit(ACCT_SET_ERRORS, ['Error while removing user login'])
      return false
    }
  },
  /***
   * Get account(s) for own/specific organization
   * @param {string} payload.fk_organization_key identifier of the organization that owns the accounts, defaults to all if user is staff
   * @param {boolean} payload.withDetails boolean to load details for each record
   * @param {string} payload.sort object to sort with, defaults to created_at desc
   * @param {number} payload.page page to return data for from database
   * @param {number} payload.pageSize size of the page count of records to return
   * @returns {*}
   */
  async [ACCT_GET_ACCOUNTS] ({ dispatch, commit, rootState }, payload) {
    commit(ACCT_SET_IS_GETTINGACCOUNTS, true)
    try {
      console.log('Retrieving accounts:', payload)
      const response = await ApiService.query('account/', payload)
      console.log('Accounts response: ', response.data)
      commit(ACCT_SET_ACCOUNTS, response.data)
      commit(ACCT_SET_IS_GETTINGACCOUNTS, false)
      commit(ACCT_SET_ERRORS, [])
      return response.data
    } catch (e) {
      const processedError = await dispatch(_PROCESS_ERROR, e)
      console.log(processedError)
      commit(ACCT_SET_IS_GETTINGACCOUNTS, false)
      commit(ACCT_SET_ACCOUNTS, [])
      commit(ACCT_SET_ERRORS, ['Error while retrieving accounts'])
      return false
      // throw await dispatch(_PROCESS_ERROR, e)
    }
  },
  /***
   * Update statement method
   * @param {string} payload.rowkey statement method string to update our account with
   * @param {string} payload.method statement method string to update our account with
   * @returns {*}
   */
  async [ACCT_UPDATE_STMT_METH] ({ dispatch, commit, rootState }, payload) {
    try {
      console.log('Updating account statement method:', payload)
      const response = await ApiService.postAction('account', payload.rowkey, 'update-statement-method', {
        method: payload.method,
      })
      console.log('Statement Update response: ', response.data)
      commit(ACCT_SET_ERRORS, [])
      return response.data
    } catch (e) {
      const processedError = await dispatch(_PROCESS_ERROR, e)
      console.log(processedError)
      commit(ACCT_SET_IS_GETTINGACCOUNT, false)
      commit(ACCT_SET_ERRORS, ['Error while updating account statement method'])
      return false
    }
  },
  /***
   * Assign billing plan
   * @param {string} payload.rowkey statement method string to update our account with
   * @param {string} payload.planId Id of the plan we want to assign which relates to a rate
   * @param {string} payload.frequency frequency to bill the rate for 1, 6, 12 months
   * @param {string} payload.quantity number of times to add the rate
   * @param {string} payload.bill_date date for next billing to occur
   * @returns {*}
   */
  async [ACCT_ASSIGN_PLAN] ({ dispatch, commit, rootState }, payload) {
    try {
      const assignPayload = {
        ...payload,
      }
      await dispatch(_COMMIT_LOG, { message: 'assigning plan to customer', assignPayload })
      const response = await ApiService.postAction('account', assignPayload.account_key, 'assign-plan', assignPayload)
      await dispatch(_COMMIT_LOG, { message: 'assigning plan response', response: response.data })
      commit(ACCT_SET_ERRORS, [])
      return response.data
    } catch (e) {
      const processedError = await dispatch(_PROCESS_ERROR, e)
      console.log(processedError)
      commit(ACCT_SET_IS_GETTINGACCOUNT, false)
      commit(ACCT_SET_ERRORS, ['Error while updating account statement method'])
      return false
    }
  },
  /***
   * Change billing plan
   * @param {string} payload.account_key statement method string to update our account with
   * @param {integer} payload.crid unique id of the customer rate to update
   * @param {integer} payload.planId Id of the plan we want to assign which relates to a rate
   * @param {string} payload.frequency frequency to bill the rate for 1, 6, 12 months
   * @param {boolean} payload.closeout number of times to add the rate
   * @param {string} payload.bill_date date for next billing to occur
   * @returns {*}
   */
  async [ACCT_CHANGE_PLAN] ({ dispatch, commit, state, rootState }, payload) {
    try {
      const assignPayload = {
        ...payload,
      }
      if (!assignPayload.account_key) {
        assignPayload.account_key = state.selectedAccount.rowkey
      }
      await dispatch(_COMMIT_LOG, { message: 'changing plan for customer', assignPayload })
      const response = await ApiService.postAction('account', assignPayload.account_key, 'change-plan', assignPayload)
      await dispatch(_COMMIT_LOG, { message: 'assigning plan response', response: response.data })
      commit(ACCT_SET_ERRORS, [])
      return response.data
    } catch (e) {
      const processedError = await dispatch(_PROCESS_ERROR, e)
      console.log(processedError)
      commit(ACCT_SET_IS_GETTINGACCOUNT, false)
      commit(ACCT_SET_ERRORS, ['Error while updating account statement method'])
      throw processedError
    }
  },
  /***
   * Remove billing plan
   * @param {string} payload.account_key statement method string to update our account with
   * @param {integer} payload.crid unique id of the customer rate to update
   * @param {boolean} payload.closeout number of times to add the rate
   * @returns {*}
   */
  async [ACCT_REMOVE_PLAN] ({ dispatch, commit, state, rootState }, payload) {
    try {
      const assignPayload = {
        ...payload,
      }
      if (!assignPayload.account_key) {
        assignPayload.account_key = state.selectedAccount.rowkey
      }
      await dispatch(_COMMIT_LOG, { message: 'removing plan for customer', assignPayload })
      const response = await ApiService.postAction('account', assignPayload.account_key, 'remove-plan', assignPayload)
      await dispatch(_COMMIT_LOG, { message: 'removing plan response', response: response.data })
      commit(ACCT_SET_ERRORS, [])
      return response.data
    } catch (e) {
      const processedError = await dispatch(_PROCESS_ERROR, e)
      commit(ACCT_SET_IS_GETTINGACCOUNT, false)
      commit(ACCT_SET_ERRORS, ['Error while updating account statement method'])
      throw processedError
    }
  },
  /***
   * Update credit card values
   * @param {string} payload.rowkey rowkey of the account to update
   * @param {string} payload.name name on card
   * @param {number} payload.number credit card number
   * @param {number} payload.month month of expiration
   * @param {number} payload.year year of expiration
   * @param {number} payload.addr1 line 1 of the address
   * @param {number} payload.city city for card address
   * @param {number} payload.state state for card address
   * @param {number} payload.zip zip for card address
   * @returns {*}
   */
  async [ACCT_UPDATE_CREDIT_CARD] ({ dispatch, commit, rootState }, payload) {
    try {
      console.log('Updating credit card details')
      commit(ACCT_SET_IS_UPDATINGPAYMENTDETAILS, true)
      const response = await ApiService.postAction('account', payload.rowkey, 'update-credit-card', {
        ...payload,
      })
      console.log('Credit card update response: ', response.data)
      commit(ACCT_SET_IS_UPDATINGPAYMENTDETAILS, false)
      commit(ACCT_SET_ERRORS_CC_FORM, [])
      return response.data
    } catch (e) {
      const processedError = await dispatch(_PROCESS_ERROR, e)
      console.log('processedErrorData', processedError)
      // commit(ACCT_SET_IS_GETTINGACCOUNT, false)
      commit(ACCT_SET_IS_UPDATINGPAYMENTDETAILS, false)
      let errors = ['Error while updating credit card details']
      if (processedError && processedError.problems && processedError.problems.length > 0) {
        errors = processedError.problems
      } else if (processedError && processedError.display_text && processedError.display_text.length > 0) {
        errors = [processedError.display_text]
      }
      commit(ACCT_SET_ERRORS_CC_FORM, errors)
      return false
    }
  },
  /***
   * Update echeck details
   * @param {string} payload.rowkey rowkey of the account to update
   * @param {string} payload.name name on account
   * @param {number} payload.number credit card number
   * @param {number} payload.month month of expiration
   * @param {number} payload.year year of expiration
   * @param {number} payload.addr1 line 1 of the address
   * @param {number} payload.city city for card address
   * @param {number} payload.state state for card address
   * @param {number} payload.zip zip for card address
   * @returns {*}
   */
  async [ACCT_UPDATE_ECHECK] ({ dispatch, commit, rootState }, payload) {
    try {
      console.log('Updating echeck details')
      commit(ACCT_SET_IS_UPDATINGPAYMENTDETAILS, true)
      const response = await ApiService.postAction('account', payload.rowkey, 'update-echeck', {
        ...payload,
      })
      console.log('Echeck update response: ', response.data)
      commit(ACCT_SET_IS_UPDATINGPAYMENTDETAILS, false)
      commit(ACCT_SET_ERRORS_ECHECK_FORM, [])
      return response.data
    } catch (e) {
      const processedError = await dispatch(_PROCESS_ERROR, e)
      console.log('processedErrorData', processedError)
      // commit(ACCT_SET_IS_GETTINGACCOUNT, false)
      commit(ACCT_SET_IS_UPDATINGPAYMENTDETAILS, false)
      let errors = ['Error while updating credit card details']
      if (processedError && processedError.problems && processedError.problems.length > 0) {
        errors = processedError.problems
      } else if (processedError && processedError.display_text && processedError.display_text.length > 0) {
        errors = [processedError.display_text]
      }
      commit(ACCT_SET_ERRORS_ECHECK_FORM, errors)
      return false
    }
  },
  /***
   * Post Charges for account
   * @param {string} payload.rowkey rowkey of the account to generate charges to
   * @param {number} payload.date date to generate charges through
   * @returns {*}
   */
  async [ACCT_POST_CHARGES] ({ dispatch, commit, rootState, state }, payload) {
    try {
      await dispatch(_COMMIT_LOG, { message: 'Posting charges for account', payload })
      const { rowkey, date } = payload
      if (!date) {
        throw new Error('Date is required to post charges to an account')
      }
      const queryPayload = {}
      queryPayload.date = date
      if (!rowkey) {
        queryPayload.rowkey = state.selectedAccount.rowkey
      }
      // commit(ACCT_SET_IS_POSTINGPAYMENT, true)
      const { data } = await ApiService.postAction('account', queryPayload.rowkey, 'post-charges', {
        ...queryPayload,
      })
      await dispatch(_COMMIT_LOG, { message: 'Posting charges for account response', query: queryPayload, response: data })
      // commit(ACCT_SET_IS_POSTINGPAYMENT, false)
      // commit(ACCT_SET_ERRORS_POST_PAYMENT, [])
      return data
    } catch (e) {
      const processedError = await dispatch(_PROCESS_ERROR, e)
      // commit(ACCT_SET_IS_GETTINGACCOUNT, false)
      let errors = ['Error while posting charges.']
      if (processedError && processedError.problems && processedError.problems.length > 0) {
        errors = processedError.problems
      } else if (processedError && processedError.display_text && processedError.display_text.length > 0) {
        errors = [processedError.display_text]
      }
      commit(ACCT_SET_ERRORS_POST_PAYMENT, errors)
      return false
    }
  },
  /***
   * Post Payment credit card
   * @param {string} payload.rowkey rowkey of the account to apply payment
   * @param {number} payload.tender amount to charge/credit the account
   * @param {array}  payload.invoices array of invoice id's to apply payment to
   * @param {string} payload.attn name on card
   * @param {number} payload.number credit card number
   * @param {number} payload.month month of expiration
   * @param {number} payload.year year of expiration
   * @param {number} payload.addr1 line 1 of the address
   * @param {number} payload.city city for card address
   * @param {number} payload.state state for card address
   * @param {number} payload.zip zip for card address
   * @returns {*}
   */
  async [ACCT_POST_PAYMENT_CC] ({ dispatch, commit, rootState }, payload) {
    try {
      console.log('Posting payment via credit card')
      commit(ACCT_SET_IS_POSTINGPAYMENT, true)
      const response = await ApiService.postAction('account', payload.rowkey, 'post-payment-cc', {
        ...payload,
      })
      console.log('Post Payment via CC response: ', response.data)
      commit(ACCT_SET_IS_POSTINGPAYMENT, false)
      commit(ACCT_SET_ERRORS_POST_PAYMENT, [])
      return response.data
    } catch (e) {
      const processedError = await dispatch(_PROCESS_ERROR, e)
      console.log('processedErrorData', processedError)
      // commit(ACCT_SET_IS_GETTINGACCOUNT, false)
      commit(ACCT_SET_IS_POSTINGPAYMENT, false)
      let errors = ['Error while posting payment.']
      if (processedError && processedError.problems && processedError.problems.length > 0) {
        errors = processedError.problems
      } else if (processedError && processedError.display_text && processedError.display_text.length > 0) {
        errors = [processedError.display_text]
      }
      commit(ACCT_SET_ERRORS_POST_PAYMENT, errors)
      return false
    }
  },
  /***
   * Post Payment echeck
   * @param {string} payload.rowkey rowkey of the account to apply payment
   * @param {number} payload.tender amount to charge/credit the account
   * @param {array}  payload.invoices array of invoice id's to apply payment to
   * @param {string} payload.attn name on card
   * @param {string} payload.acct_number account number
   * @param {string} payload.route_number bank route number
   * @param {number} payload.type bank account type 1 checking 2 savings
   * @param {string} payload.addr1 line 1 of the address
   * @param {string} payload.city city for card address
   * @param {string} payload.state state for card address
   * @param {string} payload.zip zip for card address
   * @returns {*}
   */
  async [ACCT_POST_PAYMENT_ECHECK] ({ dispatch, commit, rootState }, payload) {
    try {
      console.log('Posting payment via echeck')
      commit(ACCT_SET_IS_POSTINGPAYMENT, true)
      const response = await ApiService.postAction('account', payload.rowkey, 'post-payment-echeck', {
        ...payload,
      })
      console.log('Post Payment via echeck response: ', response.data)
      commit(ACCT_SET_IS_POSTINGPAYMENT, false)
      commit(ACCT_SET_ERRORS_POST_PAYMENT, [])
      return response.data
    } catch (e) {
      const processedError = await dispatch(_PROCESS_ERROR, e)
      console.log('processedErrorData', processedError)
      // commit(ACCT_SET_IS_GETTINGACCOUNT, false)
      commit(ACCT_SET_IS_POSTINGPAYMENT, false)
      let errors = ['Error while posting payment.']
      if (processedError && processedError.problems && processedError.problems.length > 0) {
        errors = processedError.problems
      } else if (processedError && processedError.display_text && processedError.display_text.length > 0) {
        errors = [processedError.display_text]
      }
      commit(ACCT_SET_ERRORS_POST_PAYMENT, errors)
      return false
    }
  },
  /***
   * Post Payment VOID
   * @param {string} payload.rowkey rowkey of the account to apply payment
   * @param {number} payload.tender amount to charge/credit the account
   * @param {array}  payload.invoices array of invoice id's to apply payment to
   * @returns {*}
   */
  async [ACCT_POST_PAYMENT_VOID] ({ dispatch, commit, rootState }, payload) {
    try {
      console.log('Posting payment via void')
      commit(ACCT_SET_IS_POSTINGPAYMENT, true)
      const response = await ApiService.postAction('account', payload.rowkey, 'post-payment-void', {
        ...payload,
      })
      console.log('Post Payment via echeck response: ', response.data)
      commit(ACCT_SET_IS_POSTINGPAYMENT, false)
      commit(ACCT_SET_ERRORS_POST_PAYMENT, [])
      return response.data
    } catch (e) {
      const processedError = await dispatch(_PROCESS_ERROR, e)
      console.log('processedErrorData', processedError)
      // commit(ACCT_SET_IS_GETTINGACCOUNT, false)
      commit(ACCT_SET_IS_POSTINGPAYMENT, false)
      let errors = ['Error while posting payment.']
      if (processedError && processedError.problems && processedError.problems.length > 0) {
        errors = processedError.problems
      } else if (processedError && processedError.display_text && processedError.display_text.length > 0) {
        errors = [processedError.display_text]
      }
      commit(ACCT_SET_ERRORS_POST_PAYMENT, errors)
      return false
    }
  },
  /***
   * Post Payment cash
   * @param {string} payload.rowkey rowkey of the account to apply payment
   * @param {number} payload.tender amount to charge/credit the account
   * @param {array}  payload.invoices array of invoice id's to apply payment to
   * @returns {*}
   */
  async [ACCT_POST_PAYMENT_CASH] ({ dispatch, commit, rootState }, payload) {
    try {
      dispatch(_COMMIT_LOG, { message: 'posting payment via cash', payload })
      commit(ACCT_SET_IS_POSTINGPAYMENT, true)
      const response = await ApiService.postAction('account', payload.rowkey, 'post-payment-cash', {
        ...payload,
      })
      dispatch(_COMMIT_LOG, { message: 'response payment via cash', response: response.data })
      commit(ACCT_SET_IS_POSTINGPAYMENT, false)
      commit(ACCT_SET_ERRORS_POST_PAYMENT, [])
      return response.data
    } catch (e) {
      const processedError = await dispatch(_PROCESS_ERROR, e)
      dispatch(_COMMIT_LOG, { message: 'error: payment via cash', error: processedError })
      commit(ACCT_SET_IS_POSTINGPAYMENT, false)
      let errors = ['Error while posting payment.']
      if (processedError && processedError.problems && processedError.problems.length > 0) {
        errors = processedError.problems
      } else if (processedError && processedError.display_text && processedError.display_text.length > 0) {
        errors = [processedError.display_text]
      }
      commit(ACCT_SET_ERRORS_POST_PAYMENT, errors)
      return false
    }
  },
  /***
   * Post Payment check
   * @param {string} payload.rowkey rowkey of the account to apply payment
   * @param {number} payload.tender amount to charge/credit the account
   * @param {array}  payload.invoices array of invoice id's to apply payment to
   * @param {string}  payload.check_number string with the check reference number
   * @returns {*}
   */
  async [ACCT_POST_PAYMENT_CHECK] ({ dispatch, commit, rootState }, payload) {
    try {
      dispatch(_COMMIT_LOG, { message: 'posting payment via check', payload })
      commit(ACCT_SET_IS_POSTINGPAYMENT, true)
      const response = await ApiService.postAction('account', payload.rowkey, 'post-payment-check', {
        ...payload,
      })
      dispatch(_COMMIT_LOG, { message: 'response payment via check', response: response.data })
      commit(ACCT_SET_IS_POSTINGPAYMENT, false)
      commit(ACCT_SET_ERRORS_POST_PAYMENT, [])
      return response.data
    } catch (e) {
      const processedError = await dispatch(_PROCESS_ERROR, e)
      dispatch(_COMMIT_LOG, { message: 'error: payment via check', error: processedError })
      commit(ACCT_SET_IS_POSTINGPAYMENT, false)
      let errors = ['Error while posting payment.']
      if (processedError && processedError.problems && processedError.problems.length > 0) {
        errors = processedError.problems
      } else if (processedError && processedError.display_text && processedError.display_text.length > 0) {
        errors = [processedError.display_text]
      }
      commit(ACCT_SET_ERRORS_POST_PAYMENT, errors)
      return false
    }
  },
  /***
   * Post Payment moneyorder
   * @param {string} payload.rowkey rowkey of the account to apply payment
   * @param {number} payload.tender amount to charge/credit the account
   * @param {array}  payload.invoices array of invoice id's to apply payment to
   * @param {string}  payload.check_number string with the check reference number
   * @returns {*}
   */
  async [ACCT_POST_PAYMENT_MONEYORDER] ({ dispatch, commit, rootState }, payload) {
    try {
      dispatch(_COMMIT_LOG, { message: 'posting payment via moneyorder', payload })
      commit(ACCT_SET_IS_POSTINGPAYMENT, true)
      const response = await ApiService.postAction('account', payload.rowkey, 'post-payment-moneyorder', {
        ...payload,
      })
      dispatch(_COMMIT_LOG, { message: 'response payment via moneyorder', response: response.data })
      commit(ACCT_SET_IS_POSTINGPAYMENT, false)
      commit(ACCT_SET_ERRORS_POST_PAYMENT, [])
      return response.data
    } catch (e) {
      const processedError = await dispatch(_PROCESS_ERROR, e)
      dispatch(_COMMIT_LOG, { message: 'error: payment via moneyorder', error: processedError })
      commit(ACCT_SET_IS_POSTINGPAYMENT, false)
      let errors = ['Error while posting payment.']
      if (processedError && processedError.problems && processedError.problems.length > 0) {
        errors = processedError.problems
      } else if (processedError && processedError.display_text && processedError.display_text.length > 0) {
        errors = [processedError.display_text]
      }
      commit(ACCT_SET_ERRORS_POST_PAYMENT, errors)
      return false
    }
  },
  /***
   * Get account based on external key
   * @param {string} payload.key string identifier populated in external source (id for platypus)
   * @param {string} payload.type string to indicate external type (defaults to plat)
   * @param {boolean} payload.withDetails flag to load all account details
   * @returns {*}
   */
  async [ACCT_GET_ACCOUNT_BY_EXT_KEY] ({ dispatch, commit, rootState }, payload) {
    try {
      dispatch(_COMMIT_LOG, { message: 'Retrieving account:', payload })
      const response = await ApiService.query('account/by-ext-key', payload)
      dispatch(_COMMIT_LOG, { message: 'Account details: ', payload: response.data })
      return response.data
    } catch (e) {
      const processedError = await dispatch(_PROCESS_ERROR, e)
      console.log(processedError)
      return false
    }
  },
  /***
   * Send Invoices
   * @param {string} payload.account_key UUID of the account to assign user to
   * @param {string} payload.recipient user email we want to send the invoices to
   * @param {array} payload.invoices array of invoices we want to attach
   * @returns {*}
   */
  async [ACCT_SEND_INVOICES] ({ dispatch, commit, state, rootState }, payload) {
    try {
      const sendPayload = {
        ...payload,
      }
      if (!sendPayload.account_key) {
        sendPayload.account_key = state.selectedAccount.rowkey
      }
      await dispatch(_COMMIT_LOG, { message: 'Sending invoices to recipient with payload', sendPayload })
      const response = await ApiService.postAction('account', sendPayload.account_key, 'send-invoices', sendPayload)
      await dispatch(_COMMIT_LOG, { message: 'POST:send-invoices response', response: response.data })
      return response.data
    } catch (e) {
      throw await dispatch(_PROCESS_ERROR, e)
    }
  },
}

export const mutations = {
  [ACCT_SET_ERRORS] (state, data) {
    state.errors = data
  },
  [ACCT_SET_ERRORS_CC_FORM] (state, data) {
    state.ccFormErrors = data
  },
  [ACCT_SET_ERRORS_ECHECK_FORM] (state, data) {
    state.echeckFormErrors = data
  },
  [ACCT_SET_ERRORS_POST_PAYMENT] (state, data) {
    state.postPaymentErrors = data
  },
  [ACCT_SET_ERRORS] (state, data) {
    state.errors = data
  },
  [ACCT_SET_SELECTED_ACCOUNT] (state, data) {
    state.selectedAccount = data
  },
  [ACCT_SET_SELECTED_ACCOUNT_UNPAID_INVOICES] (state, data) {
    state.selectedAccountUnpaidInvoices = data
  },
  [ACCT_SET_SELECTED_ACCOUNT_ACTIVITY] (state, data) {
    state.selectedAccountActivity = data
  },
  [ACCT_SET_SELECTED_ACCOUNT_EQUIP] (state, data) {
    state.selectedAccountEquipment = data
  },
  [ACCT_SET_SELECTED_ACCOUNT_FORMS] (state, data) {
    state.selectedAccountForms = data
  },
  [ACCT_SET_SELECTED_ACCOUNT_RATES] (state, data) {
    state.selectedAccountRates = data
  },
  [ACCT_SET_SELECTED_ACCOUNT_SERVICES] (state, data) {
    state.selectedAccountServices = data
  },
  [ACCT_SET_SELECTED_ACCOUNT_TKTS] (state, data) {
    state.selectedAccountTickets = data
  },
  [ACCT_SET_SELECTED_ACCOUNT_USERS] (state, data) {
    state.selectedAccountUsers = data
  },
  [ACCT_SET_SELECTED_ACCOUNT_INVOICES] (state, data) {
    state.selectedAccountInvoices = data
  },
  [ACCT_UPDATE_SELECTED_ACCOUNT_KEY] (state, data) {
    state.selectedAccount.rowkey = data
  },
  [ACCT_UPDATE_SELECTED_ACCOUNT] (state, data) {
    state.selectedAccount = data
  },
  [ACCT_UPDATE_SELECTED_ACCOUNT_UNPAID_INV] (state, data) {
    state.selectedAccountUnpaidInvoices = data
  },
  [ACCT_SET_ACCOUNTS] (state, data) {
    state.accounts = data
  },
  [ACCT_SET_IS_GETTINGACCOUNT] (state, data) {
    state.isGettingAccount = data
  },
  [ACCT_SET_IS_GETTINGACCOUNTS] (state, data) {
    state.isGettingAccounts = data
  },
  [ACCT_SET_IS_UPDATINGPAYMENTDETAILS] (state, data) {
    state.isUpdatingPaymentDetails = data
  },
  [ACCT_SET_IS_POSTINGPAYMENT] (state, data) {
    state.isPostingPayment = data
  },
  [ACCT_SET_IS_GETTINGACCOUNTINVOICES] (state, data) {
    state.isGettingAccountInvoices = data
  },
}
export const getters = {
  acctErrors: state => state.errors,
  acctCCErrors: state => state.ccFormErrors,
  acctEcheckErrors: state => state.echeckFormErrors,
  acctPostPaymentErrors: state => state.postPaymentErrors,
  acctAccounts: state => state.accounts,
  acctSelectedAccount: state => state.selectedAccount,
  acctSelectedAccountUnpaidInvoices: state => state.selectedAccountUnpaidInvoices,
  acctSelectedAccountActivity: state => state.selectedAccountActivity,
  acctSelectedAccountServices: state => state.selectedAccountServices,
  acctSelectedAccountInvoices: state => state.selectedAccountInvoices,
  acctSelectedAccountForms: state => state.selectedAccountForms,
  acctSelectedAccountRates: state => state.selectedAccountRates,
  acctSelectedAccountTickets: state => state.selectedAccountTickets,
  acctSelectedAccountUsers: state => state.selectedAccountUsers,
  acctIsGettingAccounts: state => state.isGettingAccounts,
  acctIsUpdatingPaymentDetails: state => state.isUpdatingPaymentDetails,
  acctIsPostingPayment: state => state.isPostingPayment,
  acctIsGettingAccountInvoices: state => state.isGettingAccountInvoices,
}

export default {
  state,
  actions,
  mutations,
  getters,
}
